<div class="container">
  <app-novo-cadastro-publicidade></app-novo-cadastro-publicidade>
  <app-novo-cadastro-form></app-novo-cadastro-form>
</div>

<p-toast></p-toast>
